<script>
  import Image from "./VideoImage.svelte";
  export let card;
</script>

<style>
  .video-card {
    display: grid;
    grid-template-columns: 1fr 0.5em 2.5fr 0.5em;
    grid-template-rows: 1fr 4fr;
    grid-template-areas:
      "video-image-background . video-title ."
      "video-image-background . video-desc .";
    width: auto;
    background-color: rgb(250, 243, 237);
	filter: drop-shadow(1px 1px 3px rgb(153, 155, 156));
	word-wrap: normal;
  }
  .video-image-background {
    grid-area: video-image-background;
    width: 100%;
    height: 100%;
    background-color: rgb(224, 143, 2);
    background-image: linear-gradient(to right, rgb(224, 143, 2) 50%, #fff 50%);
  }

  .video-image {
    width: 100%;
    height: 100%;
    overflow: hidden;
    filter: grayscale(50%) brightness(80%);
  }

  .video-title {
    grid-area: video-title;
    width: 100%;
    height: 100%;
    font-size: 1.3em;
    font-weight: 400;
    font-family: "Noto Sans TC", sans-serif;
  }
  .video-desc {
    grid-area: video-desc;
    width: 100%;
    height: auto;
    font-family: "Noto Sans TC", sans-serif;
    font-weight: 400;
    font-size: 1em;
    line-height: 1.2em;
    color: rgb(95, 95, 95);
  }
  .strands {
    font-size: 0.8em;
  }

  @media screen and (max-width: 600px) {
    .video-title {
      font-size: 1.1em;
    }
    .video-desc {
      font-size: 0.8em;
    }
    .strands {
      font-size: 0.6em;
    }
  }
</style>

<div class="video-card">
  <div class="video-image-background">
    <div class="video-image">
      <Image {card} />
    </div>
  </div>
  <div class="video-title">
    <b>{card.id}: {card.title}</b>
  </div>
  <div class="video-desc">
  {#if card.strands !== ''}
    <span class="strands">
      
        <b>Strands Covered:</b>
        {#each card.strands as strand}
          <i>{strand},</i>
        {/each}
      
    </span>
    <br />
	{/if}
    <span class="text">
      {@html card.desc}
    </span>
  </div>

</div>
